import React from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from './common/Footer';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-900 flex flex-col">
   

      <main className="flex-grow flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-md w-full space-y-8">
          <div className="text-center">
            <img
              src="/images/imr-logo.png"
              alt="IMR Logo"
              className="h-32 w-auto mx-auto mb-8"
            />
            <h1 className="mt-6 text-4xl font-extrabold text-yellow-500">404</h1>
            <h2 className="mt-2 text-3xl font-bold text-gray-200">Page Not Found</h2>
            <p className="mt-4 text-lg text-gray-400">
              The page you're looking for doesn't exist or has been moved.
            </p>
          </div>

          <div className="mt-8 flex justify-center space-x-4">
            <button
              onClick={() => navigate(-1)}
              className="px-6 py-3 border border-gray-600 rounded-md text-base font-medium text-gray-300 hover:text-yellow-500 hover:border-yellow-500 transition-colors duration-200"
            >
              Go Back
            </button>
            <button
              onClick={() => navigate('/')}
              className="px-6 py-3 bg-yellow-500 border border-transparent rounded-md text-base font-medium text-gray-900 hover:bg-yellow-600 transition-colors duration-200"
            >
              Home
            </button>
          </div>
        </div>
      </main>

      <footer className="flex-shrink-0 mt-auto">
        <Footer />
      </footer>
    </div>
  );
};

export default NotFound;
